"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIIconCircle;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIIconHolder = _interopRequireDefault(require("./UIIconHolder"));

function UIIconCircle(props) {
  var borderColor = props.borderColor,
      className = props.className,
      color = props.color,
      iconClassName = props.iconClassName,
      legacy = props.legacy,
      padding = props.padding,
      rest = (0, _objectWithoutProperties2.default)(props, ["borderColor", "className", "color", "iconClassName", "legacy", "padding"]);
  var outerCircleClassNames = (0, _classnames.default)('private-icon-circle__outer', {
    'private-icon-circle--legacy': legacy
  }, className);
  var innerCircleClassNames = (0, _classnames.default)('private-icon-circle__inner', iconClassName);
  return _react.default.createElement(_UIIconHolder.default, (0, _extends2.default)({}, rest, {
    borderColor: borderColor || color,
    borderRadius: "50%",
    className: outerCircleClassNames,
    innerClassName: innerCircleClassNames,
    padding: legacy ? 0 : padding,
    color: color
  }));
}

UIIconCircle.propTypes = {
  backgroundColor: _UIIconHolder.default.propTypes.backgroundColor,
  borderColor: _UIIconHolder.default.propTypes.borderColor,
  borderStyle: _UIIconHolder.default.propTypes.borderStyle,
  borderWidth: _UIIconHolder.default.propTypes.borderWidth,
  verticalAlign: _UIIconHolder.default.propTypes.verticalAlign,
  innerStyles: _propTypes.default.object,
  iconClassName: _propTypes.default.string,
  name: _UIIconHolder.default.propTypes.name,
  color: _propTypes.default.string,
  size: _propTypes.default.number,
  padding: _propTypes.default.number,
  legacy: _propTypes.default.bool
};
UIIconCircle.defaultProps = {
  borderWidth: 1,
  borderStyle: 'solid',
  padding: 0.75
};
UIIconCircle.displayName = 'UIIconCircle';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/icon/UIIconCircle.js
// module id = 327
// module chunks = 209 210 211 212